module.exports = __webpack_public_path__ + "static/media/news.bf24682a.jpg";